/**
 * Class representing a small vertical chart
 */
define(['jquery', 'jquerycolor'], function ($) {
   "use strict";

   return function (jList) {
      var m_aSmallChartBar;
      var m_aSmallChartLine;
      var m_iMargin;
      var m_iBarWidth;
      var m_iMinPixels;
      var m_iMaxPixels;
      var m_iMinValue;
      var m_iMaxValue;
      var self = this;
      var m_sBarLabelPostFix = "";
      var m_sNoDataText = null;
      var m_jMobile;
      var m_strSublabel;

      this.setNoDataText = function(sNoDataText) {
         m_sNoDataText = sNoDataText;
      };

      this.setBarLabelPostFix = function(sLabelPostFix) {
         m_sBarLabelPostFix = sLabelPostFix;
      };

      this.setMargin = function(iMargin) {
         m_iMargin = iMargin;
      };
      this.setBarWidth = function(iBarWidth) {
         m_iBarWidth = iBarWidth;
      };
      this.setMinMaxHeight = function(iMinPixels, iMaxPixels) {
         m_iMinPixels = iMinPixels;
         m_iMaxPixels = iMaxPixels;
      };
      this.setMinValue = function(iMinValue) {
         m_iMinValue = iMinValue;
      };
      this.setMinMaxValue = function(iMinValue, iMaxValue) {
         m_iMinValue = iMinValue;
         m_iMaxValue = iMaxValue;
      };
      this.setBarSameHeight = function(bBarSameHeight) {
      };

      this.resetData = function() {
         jList.html('');
         if (jList.data("mobile")) {
            jList.data("mobile").html('');
         }
         m_aSmallChartBar = [];
         m_aSmallChartLine = [];
         self.setMargin(5);
         self.setBarWidth(0);
         self.setMinMaxValue(0, 0);
      };

      /**
       * Internal class, used to keep track of individual bars
       */
      var SmallChartBar = function() {
         var m_strTitle,
            m_iValue,
            self = this;

         function getLi () {
            // The beginning and ending colors for the animation
            var strStartColor = '#beaf87',
               strEndColor = '#a19276',

               // Our fancy bar object
               jValue = $('<p class="value" />').html(m_iValue + m_sBarLabelPostFix),
               jBg = $('<p class="background" />').css({
                  backgroundColor : strStartColor,
               }),
               jTitle = $('<p class="title" />').html(m_strTitle),
               jLi = $('<li class="bar" />').append(jValue).append(jBg).append(jTitle),

               // Get the color of the bar when it finishes the animation
               // The more complete it is, the closer to the end color
               strBarColor = jBg.getGradientAtPercent('backgroundColor', strEndColor, getPercentage());

            jBg.css({
               backgroundColor: strBarColor
            });

            return jLi;
         }

         function getPercentage () {
            // The percentage at which the bar displays
            var iPercentage = (m_iValue - m_iMinValue) / (m_iMaxValue - m_iMinValue);
            return iPercentage;
         }

         self.setTitle = function(strTitle) {
            m_strTitle = strTitle;
         };
         self.setValue = function(iValue) {
            m_iValue = iValue;
         };
         self.getValue = function() {
            return m_iValue;
         };

         self.getElement = function(iIndex) {
            var jLi = getLi(),

               // The height... in pixels
               iPixelHeight = ((m_iMaxPixels - m_iMinPixels) * getPercentage()) + m_iMinPixels;

            jLi.attr("data-percentage", getPercentage);

            jLi.css({
               height : Math.round(iPixelHeight).toString() + 'px',
            });

            return jLi;
         };

         self.getMobileElement = function (index) {
            var jLi = getLi(),
               jBg = jLi.find(".background");

            // Uh, move some of this around
            jLi.prepend(jBg);
            jLi.prepend(jLi.find(".title"));

            jBg.css({
               width : Math.round(getPercentage() * 100).toString() + '%',
            }).append(jLi.find(".value"));

            return jLi;
         };
      };

      /**
       * Represents a line on the vertical graph
       */
      var SmallChartLine = function() {
         var m_iValue, self = this, m_iBottom = 28;

         self.setValue = function(iValue) {
            m_iValue = iValue;
         };
         self.getValue = function() {
            return m_iValue;
         };

         self.getElement = function() {
            var
               // The percentage at which the bar displays
               iPercentage = (m_iValue - m_iMinValue) / (m_iMaxValue - m_iMinValue),

               // The height... in pixels
               iPixelHeight = ((m_iMaxPixels - m_iMinPixels) * iPercentage) + m_iMinPixels + m_iBottom,

               // Our fancy bar object
               jLi = $('<li class="line"></li>').css({
                  bottom : Math.round(iPixelHeight.toString()) + 'px'
               });

            return jLi;
         };
      };

      /**
       * Add a new bar to the graph
       */
      this.addBar = function(strTitle, strValue) {
         var smallChartBar = new SmallChartBar();
         smallChartBar.setTitle(strTitle);
         smallChartBar.setValue(strValue);

         m_aSmallChartBar.push(smallChartBar);
      };

      /**
       * Add a new line to the graph
       */
      this.addLine = function(strValue) {
         var smallChartLine = new SmallChartLine();
         smallChartLine.setValue(strValue);

         m_aSmallChartLine.push(smallChartLine);
      };

      this.setSublabel = function (strSublabel) {
         m_strSublabel = strSublabel;
      };

      this.getSublabel = function () {
         return m_strSublabel;
      };

      /**
       * Adjust the graph viewport so all bars are completely visible
       */
      this.autoAdjustViewport = function() {
         var aAllItems = m_aSmallChartBar.concat(m_aSmallChartLine);

         // Set the min and max to the first bar's value
         m_iMinValue = aAllItems[0].getValue();
         m_iMaxValue = m_iMinValue;

         // Skip the first one, on purpose!
         $.each(aAllItems.slice(1), function(index, smallChartBar) {
            var iValue = smallChartBar.getValue();

            if (iValue < m_iMinValue) {
               m_iMinValue = iValue;
            } else if (iValue > m_iMaxValue) {
               m_iMaxValue = iValue;
            }
         });
         var iChartWidth = jList.width(),
            iBarWidth = (iChartWidth - m_iMargin) / m_aSmallChartBar.length;

         self.setBarWidth(iBarWidth);
      };

      /**
       * Render the bars to the list element
       */
      this.renderBars = function() {
         jList.remove(".NoDataText");

         if (m_sNoDataText !== null) {
            jList.append("<div class='NoDataText'>" + m_sNoDataText + "</div>");
            return;
         }

         m_jMobile = $("<ul>", {
            "class": "cyberMobileGraph"
         });

         $.each(m_aSmallChartBar, function(index, smallChartBar) {
            jList.append(smallChartBar.getElement());
            m_jMobile.append(smallChartBar.getMobileElement());
         });

         $.each(m_aSmallChartLine, function(index, smallChartLine) {
            var jLi = smallChartLine.getElement();
            jList.append(jLi);
         });

         // Set the inner width of the bar
         jList.find('li.bar').css({
            width : (Math.floor(10000 / m_aSmallChartBar.length) / 100).toString() + '%'
         });
      };

      this.getMobileGraph = function () {
         return m_jMobile;
      };

      this.resetData();
   };
});
